<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md center center-display">
      <div class="button close" v-if="notice.isButtonCloseShown">
        <span role="button" class="btn" @click="close">
          <IcFalse class="icn lg"/>
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">{{notice.title}}</span>
        </div>
        <div class="popup-content">
          <p class="txt" v-html="notice.text"></p>
          <div class="ta-center mt20"
            v-if="notice.isButton1Shown && notice.isButton2Shown"
            >
            <div class="button inline" style="display: inline-block;"
              @click="click.submit1"
              >
              <span role="button" class="btn">{{notice.button1Text}}</span>
            </div>
            <div class="button inline" style="display: inline-block;"
              @click="click.submit2"
              >
              <span role="button" class="btn">{{notice.button2Text}}</span>
            </div>
          </div>
          <div class="button mt32"
            v-else-if="notice.isButton1Shown"
            @click="click.submit1"
            >
            <span role="button" class="btn">{{notice.button1Text}}</span>
          </div>
          <div class="button mt32"
            v-else-if="notice.isButton2Shown"
            @click="click.submit2"
            >
            <span role="button" class="btn">{{notice.button2Text}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { SystemNotice } from '@/logic/common/SystemNotice'

export default defineComponent({
  setup (props, context) {
    return { ...SystemNotice(context) }
  }
})
</script>

<style lang="scss" scoped>
  .popup-container{
    .close{
      position: absolute;
      bottom: 0;
      right: -20px;
      width: 95px;
      height: 78px;
      z-index: 10;
      span{
        border-radius: 8px 0 0 0;
        border: none;
        box-shadow: 0 -5px 20px rgb(0 0 0 / 16%);
        color: #999;
        .icn{
          top: 30px;
        }
      }
    }
  }
  .popup-content{
    .txt {
      margin: 20px 20px 30px;
    }
    .button {
      width: 267px;
      margin-right: auto;
      margin-left: auto;
      margin-bottom: 20px;
    }
  }
</style>
